module.exports = __webpack_public_path__ + "static/adoucisseur1-96a22364a69289b0f88f3dfb9f52ea73.jpg";